import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=66b38c86&scoped=true"
import script from "./quotation.vue?vue&type=script&lang=js"
export * from "./quotation.vue?vue&type=script&lang=js"
import style0 from "./quotation.vue?vue&type=style&index=0&id=66b38c86&prod&scoped=true&lang=css"
import style1 from "./quotation.vue?vue&type=style&index=1&id=66b38c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b38c86",
  null
  
)

export default component.exports